import { css, Theme } from '@emotion/react'
import { chipClasses } from '@mui/material'

export const title = (theme: Theme) => css`
  display: block;
  margin-top: ${theme.spacing(3)};

  font-size: 22px;
  font-weight: 700;
`

export const tabs = css`
  margin: 24px 0 24px;
`

export const tooltipDescription = css`
  margin-bottom: 24px;
`

export const listWrapper = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  gap: 10px;

  margin-top: 24px;
  padding: 13px;
  border: 1px solid ${theme.backgrounds.backgroundOne};
  border-radius: 14px;
`

export const emptyList = (theme: Theme) => css`
  align-items: center;
  padding: 31px 14px;
  color: ${theme.typographyColors.typographyFour};
`

export const listItem = (theme: Theme) => css`
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 5px 5px 5px 10px;
  border: 1px solid ${theme.backgrounds.backgroundOne};
  border-radius: 14px;
  box-shadow: ${theme.boxShadows.small};

  background-color: ${theme.colors.backgroundFive};
`

export const actions = (theme: Theme) => css`
  display: flex;
  align-items: center;
  gap: ${theme.spacing(1)};
`

export const chip = (theme: Theme) => css`
  padding: 5px 9px;
  border-radius: 6px;
  border: 1px solid ${theme.colors.backgroundOne};

  background-color: ${theme.colors.white};

  .${chipClasses.label} {
    padding: 0;

    font-size: 14px;
    font-weight: 500;
    line-height: normal;
  }
`

export const icon = (theme: Theme) => css`
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 36px;
  height: 36px;
  padding: 8px;
  gap: 5px;
  border-radius: 10px;
  border: 1px solid ${theme.backgrounds.backgroundOne};
  background: ${theme.backgrounds.backgroundFour};
  box-shadow: ${theme.boxShadows.small};
`

export const iconEdit = (theme: Theme) => css`
  color: ${theme.backgrounds.backgroundOne};
`

export const iconCross = (theme: Theme) => css`
  color: ${theme.colors.red};
`

export const autocompleteItem = css`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const taskTitle = css`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  max-height: 20px;
`
